module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYAGM3gsDEAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4+MhwWJiAeHCokPDIwPj4+Pj///8QXvWZAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABuSURBVAgdXcHBCQJAEATBFQxAMYMdNgBvnL+gETRc/qn4Pqvq+j286+PDq/ynvPcoyuwRwWV6FKUZYFTG0QITYKm8iTwy2bBVpiNHJgOjMo4cmQxEZZxNlD3NoHJ7dS+tbvVql//Uw4dnXe6H2w+gNi1Ku2ytpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Flying.png
// module id = 164
// module chunks = 0